import React, { useContext } from "react";
import { MenuItem } from "../hooks/useHeader";
import { MobileNavButton } from "./MobileNavButton";
import environments from "../../../utils/config/environments";
import { LangContext } from "../../../context/lang/LangContext";
import { MobileLangSelect } from "../../MobileLangSelect/MobileLangSelect";

interface Props {
  items: MenuItem[];
  handleOpenMenu: () => void;
  isOpen: boolean;
}

export const MobileNavMenu = ({ items, handleOpenMenu, isOpen }: Props) => {
  const { messages } = useContext(LangContext);

  return (
    <div
      className={
        "Header__mobile_nav_menu " + (isOpen ? "" : "Header__mobile_nav_closed")
      }
    >
      {items.map((item, index) => (
        <MobileNavButton
          handleOpenMenu={handleOpenMenu}
          key={index}
          item={item}
        />
      ))}
      <a
        href={environments.signInLink}
        className="Landing__button Landing__button_secondary"
        target="_blank"
        style={{
          width: "300px",
          marginBottom: "16px",
        }}
        rel="noreferrer"
      >
        {messages.header.buttons.signIn}
      </a>
      <a
        href={environments.createAccountLink}
        className="Landing__button"
        target="_blank"
        style={{
          width: "300px",
        }}
        rel="noreferrer"
      >
        {messages.header.buttons.getPricing}
      </a>
      <MobileLangSelect />
    </div>
  );
};
